import React, { ReactElement } from 'react';
import TermsAndConditions from 'components/pages/TermsAndConditions';
import { ServerSideInitProps } from 'types/types';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page = (): ReactElement => {
    return <TermsAndConditions />;
};

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    const props = await getPageProps<Props>({
        givenProps: {},
        req,
        res,
        api,
        query,
        translatePage: true,
        nameSpaces: getPageNamespaces('/clenstvi-podminky'),
    });

    return {
        props,
    };
};

export default Page;
